

export default class PopupWindow{
    static showpopup(text: String){
        alert(text);
    }
}